import { useCallback, useState } from 'react';

/**
 *
 * Transform asynchronous error to synchronous.
 *
 */
export function useAsyncError() {
  const [, setError] = useState();

  return useCallback(
    <E = unknown>(error: E) => {
      setError(() => {
        // eslint-disable-next-line
        throw error;
      });
    },
    [setError],
  );
}
